export const ROLES = {
  BROKER: "broker",
  CLAIMS_HANDLER: "claim_handler",
  UNDERWRITER: "underwriter",
  READ_ONLY: "read_only",
};

export default ROLES;
